var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#D1D1D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5224 11.6682H21.9507V23H9V11.6682H11.4283V10.0493C11.4283 7.68583 13.4599 5.79179 15.872 6.01843C17.9764 6.22078 19.5224 8.10672 19.5224 10.2193V11.6682ZM13.0471 10.0493V11.6682H17.9036V10.0493C17.9036 8.70569 16.819 7.62107 15.4753 7.62107C14.1317 7.62107 13.0471 8.70569 13.0471 10.0493ZM17.0957 15.7161H13.858V18.9537H17.0957V15.7161Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.04554c10f63cb3f3fc0f766e935e2c27.svg";
export { ForwardRef as ReactComponent };